
// @require ./cash.js

export function isFunction ( x ) {
  return typeof x === 'function';
}

export function isString ( x ) {
  return typeof x === 'string';
}

export function isNumeric ( x ) {
  return !isNaN ( parseFloat ( x ) ) && isFinite ( x );
}

export const isArray = Array.isArray;
